export default {
  MODULE_NAME: 'organization',
};
